import { AlertTriangle, Hand } from "lucide-react";

// Interne Kennzeichen einer Position (Schätzwert bei Kalkulation, Preis manuell).
export function PositionKalkBadges({ p, idx }) {
  const estimated = !!p.kalk?.result?.estimated;
  if (!estimated && !p.preis_manuell) return null;
  return (
    <div className="flex items-center gap-1 flex-wrap mt-1">
      {estimated && (
        <span className="text-[10px] px-1.5 py-0.5 rounded border bg-amber-50 text-amber-800 border-amber-200 inline-flex items-center gap-1" title="Kein exaktes Slicer-Ergebnis – bitte Preis prüfen." data-testid={`pos-estimated-${idx}`}>
          <AlertTriangle className="w-3 h-3" /> Schätzwert
        </span>
      )}
      {p.preis_manuell && (
        <span className="text-[10px] px-1.5 py-0.5 rounded border bg-slate-100 text-slate-700 border-slate-300 inline-flex items-center gap-1" title={p.kalk ? "Preis manuell geändert – keine automatische Neuberechnung (erneutes Kalkulieren setzt den Preis zurück)." : "Preis manuell geändert – fester Bruttopreis aufgehoben."} data-testid={`pos-manual-${idx}`}>
          <Hand className="w-3 h-3" /> Preis manuell
        </span>
      )}
    </div>
  );
}
